import React from 'react';
import {Trans} from 'react-i18next';
import LeftTitleWithField from '../../layout/LeftTitleWithField';
import {Field} from 'formik';
import _get from 'lodash/get';
import CustomSwitch from '../../../../../components/layout/CustomSwitch';
import Section from '../../layout/Section';
import useSkincare from '../../../../../components/hook/useSkincare';
import {useSelector} from 'react-redux';
import {
  isSkinHealthScoreValid,
  rangeStyle,
  scoreRanges,
} from '../../../../../utils/skincareUtils';
import InputBox from '../../../../../components/formik/InputBox';
import {toast} from 'react-toastify';
import ColorField from '../../../../../components/product/color/colorfield';

export default function ResultPageSettings({formikProps}) {
  const accountSummary = useSelector(
    state => state.components.auth.accountSummary
  );
  const {isSupportSkinType} = useSkincare(accountSummary);
  return (
    <Section
      title={
        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.result.page.settings">
          Result Page Settings
        </Trans>
      }
    >
      <LeftTitleWithField
        title={
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.show.timestamp">
            Show Time Stamp
          </Trans>
        }
      >
        <Field
          name="skinResultPage.skinReport.resultPage.showTimeStamp"
          value={_get(
            formikProps.values,
            'skinResultPage.skinReport.resultPage.showTimeStamp'
          )}
          component={CustomSwitch}
        />
      </LeftTitleWithField>
      {isSupportSkinType && (
        <LeftTitleWithField
          title={
            <Trans i18nKey="p.s.uiconfiguration.skinresultpage.show.skintype">
              Show Skin Type
            </Trans>
          }
        >
          <Field
            name="skinResultPage.skinReport.resultPage.showSkinType"
            value={_get(
              formikProps.values,
              'skinResultPage.skinReport.resultPage.showSkinType'
            )}
            component={CustomSwitch}
          />
        </LeftTitleWithField>
      )}
      <LeftTitleWithField
        title={
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.show.skin.age">
            Show Skin Age
          </Trans>
        }
      >
        <Field
          name="skinResultPage.skinReport.resultPage.showSkinAge"
          value={_get(formikProps.values, 'skinResultPage.skinReport.resultPage.showSkinAge')}
          component={CustomSwitch}
        />
      </LeftTitleWithField>
      <LeftTitleWithField
        title={
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.show.skin.score">
            Show Skin Score
          </Trans>
        }
      >
        <Field
          name="skinResultPage.skinReport.resultPage.showSkinScore"
          value={_get(
            formikProps.values,
            'skinResultPage.skinReport.resultPage.showSkinScore'
          )}
          component={CustomSwitch}
        />
      </LeftTitleWithField>
      <LeftTitleWithField
        title={
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.show.skin.score.comment">
            Show Skin Score Comment
          </Trans>
        }
      >
        <Field
          name="skinResultPage.skinReport.resultPage.showSkinScoreComment"
          value={_get(
            formikProps.values,
            'skinResultPage.skinReport.resultPage.showSkinScoreComment'
          )}
          component={CustomSwitch}
        />
      </LeftTitleWithField>
      <h6 className="kt-margin-t-10">
        <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.skin.health.score.bar">
          Skin Health Score Bar
        </Trans>
      </h6>
      <LeftTitleWithField
        title={
          <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.rate.range">
            Rate Range
          </Trans>
        }
      >
        <div className="d-flex flex-wrap align-items-center">
          <span>0</span>
          <label
            htmlFor={`skinResultPage.skinReport.resultPage.scoreBar.avgLowerBound`}
            style={rangeStyle}
          >
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.rate.range.not.good">
              Fair
            </Trans>
          </label>
          <Field name={`skinResultPage.skinReport.resultPage.scoreBar.avgLowerBound`}>
            {props => (
              <InputBox
                {...props}
                containerClassname=" "
                style={{width: '70px'}}
                type="number"
                max={99}
                min={1}
                onBlur={val => {
                  if (
                    !isSkinHealthScoreValid(formikProps.values, 'lower', val)
                  ) {
                    toast.error(
                      <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.rate.range.lower.bound.error">
                        Score rate range average lower bound must be less than
                        average upper bound.
                      </Trans>
                    );
                  }
                }}
              />
            )}
          </Field>
          <label
            htmlFor={`skinResultPage.skinReport.resultPage.scoreBar.avgUpperBound`}
            style={rangeStyle}
          >
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.rate.range.average">
              Average
            </Trans>
          </label>
          <Field name={`skinResultPage.skinReport.resultPage.scoreBar.avgUpperBound`}>
            {props => (
              <InputBox
                {...props}
                style={{width: '70px'}}
                type="number"
                max={99}
                min={1}
                onBlur={val => {
                  if (
                    !isSkinHealthScoreValid(formikProps.values, 'upper', val)
                  ) {
                    toast.error(
                      <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.rate.range.upper.bound.error">
                        Score rate range average upper bound must be greater
                        than average lower bound.
                      </Trans>
                    );
                  }
                }}
              />
            )}
          </Field>
          <div style={rangeStyle}>
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.rate.range.good">
              Good
            </Trans>
          </div>
          100
        </div>
      </LeftTitleWithField>
      <LeftTitleWithField
        title={
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.bar.color">
            Bar Color
          </Trans>
        }
      >
        <div className="form-group">
          <div>
            <div className="d-flex align-items-center kt-margin-b-10">
              <div style={{width: '70px'}} />
              <div
                className="text-default text-center"
                style={{
                  width: '180px',
                  marginRight: '10px',
                }}
              >
                <Trans i18nKey="p.s.uiconfiguration.skinresultpage.bar.color.left">
                  Left
                </Trans>
              </div>
              <div
                className="text-default text-center"
                style={{width: '180px'}}
              >
                <Trans i18nKey="p.s.uiconfiguration.skinresultpage.bar.color.right">
                  Right
                </Trans>
              </div>
            </div>
            {scoreRanges(2).map(range => (
              <div
                key={range.value}
                className="d-flex align-items-center kt-margin-b-10"
              >
                <label
                  className="kt-margin-r-10 text-right"
                  style={{width: '50px'}}
                >
                  {range.label}
                </label>
                <div className="kt-margin-r-10">
                  <Field
                    name={`skinResultPage.skinReport.resultPage.scoreBar.barColors.${
                      range.key
                    }[0]`}
                    component={ColorField}
                  />
                </div>
                <div>
                  <Field
                    name={`skinResultPage.skinReport.resultPage.scoreBar.barColors.${
                      range.key
                    }[1]`}
                    component={ColorField}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </LeftTitleWithField>
    </Section>
  );
}
